module.exports = __webpack_public_path__ + "img/img-6.246bacee.webp";